import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import VueTelInput from 'vue-tel-input'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/pc_style.less'
import './assets/iconfont/iconfont.css'
import './assets/css/mobile_style.less'
import './assets/css/index.less'
// import './assets/js/gVerify';
import Api from './service/api.js'
import VueAxios from 'vue-axios'
import i18n from '@/assets/lang/index'
import preventClick from './assets/js/preventClick.js'

// sentry
// import * as Sentry from '@sentry/vue'
// import { Integrations } from '@sentry/tracing'
// Sentry.init({
//   Vue,
//   dsn: 'https://e6f5bbf2726b4c96bea7bf9eb476f739@o982456.ingest.sentry.io/5946951',
//   integrations: [
//     new Integrations.BrowserTracing({
//       routingInstrumentation: Sentry.vueRouterInstrumentation(router),
//       tracingOrigins: ['localhost', 'my-site-url.com', /^\//]
//     })
//   ],
//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for performance monitoring.
//   // We recommend adjusting this value in production
//   tracesSampleRate: 0.2
// })

Vue.prototype.qs = require('qs')
// Vue.use(ElementUI);
Vue.use(VueTelInput, {
  enabledCountryCode: true,
  inputClasses: 'telephone',
  placeholder: 'Phone number',
  validCharactersOnly: true,
  defaultCountry: 'US',
  mode: 'national',
  customValidate: false
})
Vue.use(preventClick)
Vue.use(VueAxios, Api.axios)
Vue.use(ElementUI, {
  i18n: (key, val) => i18n.t(key, val) // 用于elementUI插件的中英文翻译
})

Vue.config.productionTip = false

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
